<template>
  <CommonPages id="services" classs="services-page" titlePrefix="Services - Zephyrcade"
    metaDescription="Zephyrcade is a digital media trading platform that connects advertisers and publishers. We provide efficient ad placement, real-time analytics, and smart optimization tools to maximize performance and revenue.">
    <div class="page-header"></div>
    <section class="services-section">
      <div class="services-section__header">
        <h2 class="services-section__title">Services we offer for you</h2>
        <p class="services-section__subtitle">
          We deliver premium advertising inventory to empower advertisers in scaling campaigns and
          achieving optimal ROI.
        </p>
      </div>
      <div class="services-section__grid">
        <div class="service-card" v-for="(service, index) in services" :key="index">
          <img :src="service.image" :alt="service.title" class="service-card__image">
          <div class="service-card__content">
            <h3 class="service-card__title">{{ service.title }}</h3>
            <p class="service-card__description">{{ service.description }}</p>
          </div>
        </div>
      </div>
    </section>
    <section class="how-it-works-section">
      <div class="how-it-works-section__header">
        <h2 class="how-it-works-section__title">How dose it work ?</h2>
      </div>
      <div class="how-it-works-section__grid">
        <div class="work-step" v-for="(step, index) in workSteps" :key="index">
          <div class="work-step__icon-container">
            <img :src="step.icon" :alt="step.title" class="work-step__icon">
          </div>
          <div class="work-step__content">
            <h3 class="work-step__title">{{ step.title }}</h3>
            <p class="work-step__description">{{ step.description }}</p>
          </div>
        </div>
      </div>
    </section>
  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue';
import '@/css/services.scss';

export default {
  name: 'Services',
  components: {
    CommonPages,
  },
  data () {
    return {
      services: [
        {
          title: 'Premium Inventory Access',
          description: 'Gain access to high-quality ad placements across trusted publishers and premium digital channels.',
          image: require('@/assets/service-1.png')
        },
        {
          title: 'Real-Time Bidding',
          description: 'Leverage advanced programmatic technology to bid efficiently and reach your audience at the right moment.',
          image: require('@/assets/service-2.png')
        },
        {
          title: 'Campaign Optimization',
          description: 'Maximize performance with data-driven strategies, continuous testing, and smart targeting adjustments.',
          image: require('@/assets/service-3.png')
        },
        {
          title: 'Dedicated Support',
          description: 'Work with an expert team that provides 24/7 assistance, ensuring smooth execution and measurable results.',
          image: require('@/assets/service-4.png')
        }
      ],
      workSteps: [
        {
          title: 'Sign Up and Verify',
          description: 'Create your account and complete the verification process to get started.',
          icon: require('@/assets/connect-1.svg')
        },
        {
          title: 'Connect Your Ad Accounts',
          description: 'Link your advertising platform accounts for seamless integration.',
          icon: require('@/assets/connect-2.svg')
        },
        {
          title: 'Browse and Select Inventory',
          description: 'Explore available ad spaces across multiple platforms and choose what fits your campaign.',
          icon: require('@/assets/connect-3.svg')
        },
        {
          title: 'Place Bids and Trade',
          description: 'Participate in real-time bidding to purchase premium ad inventory efficiently.',
          icon: require('@/assets/connect-4.svg')
        },
        {
          title: 'Launch and Monitor Campaigns',
          description: 'Activate your campaigns and track performance with real-time analytics.',
          icon: require('@/assets/connect-5.svg')
        },
        {
          title: 'Optimize and Scale',
          description: 'Use insights and expert support to continuously improve and expand your advertising efforts.',
          icon: require('@/assets/connect-6.svg')
        }
      ]
    };
  }
};
</script>
